import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/api";
import { Roundel, SunIcon } from "../../components/brand/icons";

export default function AdminLoginPage() {
  const { user, login, logout } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-offwhite px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-charcoal p-8 lg:p-10">
        <Roundel className="mb-8 h-20 w-20 text-charcoal" />
        <h1 className="h-condensed text-3xl">Pantheon CMS</h1>

        {user ? (
          <div className="mt-8 space-y-4" data-testid="admin-session-panel">
            <p className="body-text text-sm">
              Signed in as <strong className="font-medium">{user.email}</strong> ({user.role}).
            </p>
            <div className="flex items-center gap-6">
              <Link to="/admin" data-testid="admin-goto-dashboard" className="link-arrow text-xs">
                Go to dashboard
              </Link>
              <button
                type="button"
                data-testid="admin-logout-button"
                onClick={logout}
                className="link-arrow text-xs"
              >
                Sign out
              </button>
            </div>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="admin-login-form">
            <div>
              <label htmlFor="admin-email" className="eyebrow mb-2 block">
                Email
              </label>
              <input
                id="admin-email"
                data-testid="admin-login-email-input"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-charcoal bg-transparent px-3 py-2.5 text-sm outline-none focus:ring-1 focus:ring-charcoal"
              />
            </div>
            <div>
              <label htmlFor="admin-password" className="eyebrow mb-2 block">
                Password
              </label>
              <input
                id="admin-password"
                data-testid="admin-login-password-input"
                type="password"
                required
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-charcoal bg-transparent px-3 py-2.5 text-sm outline-none focus:ring-1 focus:ring-charcoal"
              />
            </div>
            {error && (
              <p className="text-sm" role="alert" data-testid="admin-login-error">
                {error}
              </p>
            )}
            <button
              type="submit"
              data-testid="admin-login-submit-button"
              disabled={busy}
              className="link-arrow text-xs disabled:opacity-50"
            >
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
        )}

        <div className="mt-10 flex items-center justify-between gap-4 text-xs tracking-wide">
          <span className="flex items-center gap-2">
            <SunIcon className="h-4 w-4" />
            <span>Pantheon Art Limited</span>
          </span>
          <Link to="/admin/forgot-password" className="link-arrow text-xs" data-testid="forgot-password-link">
            Forgot password?
          </Link>
        </div>
      </div>
    </div>
  );
}
